<!-- @WARN do not use ngModel on ispui-checkbox! It's not working with disabled attribute. Don't know how it's related, but it's a fact -->
<ispui-checkbox
  *ngIf="!toggle; else toggleEl"
  returnType="string"
  [name]="name"
  [minus]="minus"
  [labelPosition]="labelPosition"
  [disabled]="disabled"
  [checked]="value"
  (change)="onValueChange($event)"
  class="checkbox__component"
>
  <span
    [innerHTML]="caption"
    [ngClass]="[this.color ? 'checkbox__label_' + this.color : '']"
  ></span>
</ispui-checkbox>

<ng-template #toggleEl>
  <ispui-toggle
    [disabled]="disabled"
    [ngModel]="value === 'on'"
    (ngModelChange)="
      onValueChange({ detail: { checked: $event ? 'on' : 'off' } })
    "
    theme="primary"
    [label]="caption"
  ></ispui-toggle>
</ng-template>
